import {TradeTagDb} from './tradeTagDbSchema';
import {TradeTagWrite, tradeTagWriteSchema} from './tradeTagWriteSchema';

export function mapTradeTagWriteToDb(write: TradeTagWrite): TradeTagDb {
  return tradeTagWriteSchema.parse({
    ...write,
  });
}
